import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL;
const APP_TOKEN = process.env.REACT_APP_APP_TOKEN;

const glpiService = {
  // Métodos existentes...
  initSession: async (username, password) => {
    const response = await axios.post(
      `${BASE_URL}/initSession`,
      {},
      {
        headers: {
          Authorization: `Basic ${btoa(`${username}:${password}`)}`,
          "App-Token": APP_TOKEN,
        },
      }
    );
    return response.data; // Devuelve el token y otros datos
  },

  killSession: async (sessionToken) => {
    const response = await axios.post(
      `${BASE_URL}/killSession`,
      {},
      {
        headers: {
          "Session-Token": sessionToken,
          "App-Token": APP_TOKEN,
        },
      }
    );
    return response.data;
  },

  getTickets: async (sessionToken, range = "0-10") => {
    const response = await axios.get(`${BASE_URL}/Ticket`, {
      headers: {
        "Session-Token": sessionToken,
        "App-Token": APP_TOKEN,
      },
    });
    console.log(response);
    return response.data;
  },

  searchTickets: async (sessionToken, queryParams = {}) => {
    const response = await axios.get(`${BASE_URL}/search/Ticket`, {
      headers: {
        "Session-Token": sessionToken,
        "App-Token": APP_TOKEN,
      },
      params: queryParams,
    });
    return response.data;
  },

  getFullSession: async (sessionToken) => {
    const response = await axios.get(`${BASE_URL}/getFullSession`, {
      headers: {
        "Session-Token": sessionToken,
        "App-Token": APP_TOKEN,
      },
    });
    return response.data; // Devuelve la información completa de la sesión
  },

  // Nuevos métodos

  getEntities: async (sessionToken) => {
    const response = await axios.get(`${BASE_URL}/Entity?range=0-1000`, {
      headers: {
        "Session-Token": sessionToken,
        "App-Token": APP_TOKEN,
      },
    });
    console.log(response.data);
    return response.data; // Devuelve las entidades disponibles

  },

  getTicketCategories: async (sessionToken) => {
    const response = await axios.get(`${BASE_URL}/ITILCategory`, {
      headers: {
        "Session-Token": sessionToken,
        "App-Token": APP_TOKEN,
      },
    });
    return response.data; // Devuelve las categorías de tickets
  },
};

export default glpiService;
